module.exports = {
  bpmnImporter: [ 'type', require(6) ]
};